var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"switch switch-variables",attrs:{"role":"switch","type":"button","aria-checked":_vm.value},on:{"click":_vm.onClick}},'button',Object.assign({}, _vm.$attrs),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }